<template>
  <div>
    <div v-for="n in 8" :key="n" class="flex w-full px-2">
      <div class="w-2/12 flex align-items-center">
        <BoxesShimmer :boxes="1" border-radius="50%" box-height="45px" box-width="45px" background-color="rgba(255, 249, 249, 0.1)"/>
      </div>
      <div class="w-10/12">
        <LinesShimmer :lines="2" background-color="rgba(255, 249, 249, 0.1)" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import BoxesShimmer from '@/components/UILibrary/Shimmers/BoxesShimmer.vue'
import LinesShimmer from '@/components/UILibrary/Shimmers/LinesShimmer.vue'

@Component({
  components: { LinesShimmer, BoxesShimmer }
})
export default class InboxLoading extends Vue {

}
</script>

<style scoped>

</style>
